import { useTranslation } from "react-i18next";
import { ContractModificationGround } from "../../../autogen/bff-api";
import type { ModificationRegime } from "./modificationGrounds";

export const useModificationTexts = () => {
  const { t } = useTranslation();

  const groundLabel = (ground: ContractModificationGround): string =>
    ground === ContractModificationGround.AdditionalDeliveries
      ? t("Additional deliveries (letter c)")
      : t("Unforeseen circumstances (letter d)");

  const conditions = (ground: ContractModificationGround, regime: ModificationRegime): string => {
    if (ground === ContractModificationGround.AdditionalDeliveries) {
      return regime === "foa"
        ? t("FOA § 28-1 (1) c: additional deliveries, with the 50 % cap")
        : t("Forsyningsforskriften § 24-1 (1) c: additional deliveries");
    }
    return regime === "foa"
      ? t("FOA § 28-1 (1) d: unforeseen circumstances, with the 50 % cap")
      : t("Forsyningsforskriften § 24-1 (1) d: unforeseen circumstances");
  };

  return { groundLabel, conditions };
};
